<template>
  <v-container>
    <v-overlay v-model="overlay" color="white" opacity="1" persistent>
      <v-container style="text-align: center">
        <v-progress-circular :size="50" color="#234a98" indeterminate></v-progress-circular>
        <p class="pt-2" style="font-size: 14px; color: #234a98">
          {{ $t('common.loading') }}
        </p>
      </v-container>
    </v-overlay>
    <v-dialog v-model="scelta" max-width="800" persistent>
      <v-card class="mb-4" width="100%" flat>
        <v-card-title>
          {{ $t('airQuality.selectSensor') }}
        </v-card-title>
        <v-card-text>
          <v-layout class="mt-4" id="makeMeBlue">
            <v-flex xs6 sm3 md3>
              <v-select class="v-select" v-model="client" :items="clients" :label="$t('manageSensors.client')" outlined :no-data-text="$t('common.noDataAvailable')">
              </v-select>
            </v-flex>
            <v-flex xs6 sm3 md3>
              <v-select class="ml-2" v-model="building" :items="buildings" :label="$t('manageSensors.building')" outlined
                :disabled="buildingActive" :no-data-text="$t('common.noDataAvailable')">
              </v-select>
            </v-flex>
            <v-flex xs6 sm3 md3>
              <v-select class="ml-2" v-model="floor" :items="floors" :label="$t('manageSensors.floor')" outlined :disabled="floorActive" :no-data-text="$t('common.noDataAvailable')">
              </v-select>
            </v-flex>
            <v-flex xs6 sm3 md3>
              <v-select class="ml-2" v-model="area" :items="areas" :label="$t('manageSensors.area')" outlined :disabled="areaActive" :no-data-text="$t('common.noDataAvailable')">
              </v-select>
            </v-flex>
            <v-flex xs6 sm3 md3>
              <v-select class="ml-2" v-model="sensorsValue" :items="sensor_items" :label="$t('manageSensors.sensor')" outlined :key="s"
                :disabled="sensorActive" :no-data-text="$t('common.noDataAvailable')">
              </v-select>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="#213A8F" @click="goBack">{{ $t('common.back').toUpperCase() }}</v-btn>
          <v-btn text color="#213A8F" :disabled="okActive" @click="LoadData()">{{ $t('common.ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card width="100%" flat v-show="!scelta">
      <v-card-text>
        <v-layout class="mt-4" id="changeMyColor">
          <v-flex xs6 sm3 md3>
            <v-select class="v-select" v-model="client" :items="clients" label="Client" outlined :no-data-text="$t('common.noDataAvailable')">
            </v-select>
          </v-flex>
          <v-flex xs6 sm3 md3>
            <v-select class="ml-2" v-model="building" :items="buildings" :label="$t('manageSensors.building')" outlined :key="b" :no-data-text="$t('common.noDataAvailable')">
            </v-select>
          </v-flex>
          <v-flex xs6 sm3 md3>
            <v-select class="ml-2" v-model="floor" :items="floors" :label="$t('manageSensors.floor')" outlined :key="f"
              :disabled="floorActive" :no-data-text="$t('common.noDataAvailable')">
            </v-select>
          </v-flex>
          <v-flex xs6 sm3 md3>
            <v-select class="ml-2" v-model="area" :items="areas" :label="$t('manageSensors.area')" outlined :disabled="areaActive" :no-data-text="$t('common.noDataAvailable')">
            </v-select>
          </v-flex>
          <v-flex xs6 sm3 md3>
            <v-select class="ml-2" v-model="sensorsValue" :items="sensor_items" :label="$t('manageSensors.sensor')" outlined :key="s"
              :disabled="sensorActive" :no-data-text="$t('common.noDataAvailable')">
            </v-select>
          </v-flex>
          <v-flex xs6 sm3 md3 class="ml-2">
            <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="date"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field outlined v-model="date" :label="$t('smartDispenser.selectDateRange')" prepend-inner-icon="mdi-calendar"
                  readonly v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="date" no-title scrollable locale="en" range :max="maxDate" :min="minDate"
                @click="SetMinDate">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  {{ $t('common.cancel') }}
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(date); GetDataByDate()">
                  {{ $t('common.ok') }}
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
        <hr class="mt-4" style="border-top: solid 1px; color: #BFCCE4" />
        <v-layout v-show="visualizza_dati && !scelta">
          <v-flex xs2 sm6 md3 class="mt-6 mb-4 mr-0 ml-0 justify-left">
            <h2 style="font-weight: bold;">{{ $t('smartDispenser.quickFilters') }} </h2>
          </v-flex>
          <v-flex xs2 sm6 md3>
            <v-btn text @click="ChangeDate('4h', request)" class="mt-4 mb-4 mr-0 ml-0">
              <h2 :style="'color: ' + colore4h">| {{ $t('smartDispenser.hours') }} |</h2>
            </v-btn>
          </v-flex>
          <v-flex xs2 sm6 md3>
            <v-btn text @click="ChangeDate('1', request)" class="mt-4 mb-4 mr-0 ml-0">
              <h2 :style="'color: ' + colore1d">| {{ $t('smartDispenser.day') }} |</h2>
            </v-btn>
          </v-flex>
          <v-flex xs2 sm6 md3>
            <v-btn text @click="ChangeDate('3', request)" class="mt-4 mb-4 mr-0 ml-0">
              <h2 :style="'color: ' + colore3d">| {{ $t('smartDispenser.threeDays') }} |</h2>
            </v-btn>
          </v-flex>
          <v-flex xs2 sm6 md3>
            <v-btn text @click="ChangeDate('7', request)" class="mt-4 mb-4 mr-0 ml-0">
              <h2 :style="'color: ' + colore1w">| {{ $t('smartDispenser.week') }} |</h2>
            </v-btn>
          </v-flex>
          <v-flex xs2 sm6 md3>
            <v-btn text @click="ChangeDate('14', request)" class="mt-4 mb-4 mr-0 ml-0">
              <h2 :style="'color: ' + colore2w">| {{ $t('smartDispenser.twoWeeks') }} |</h2>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <hr style="border-top: solid 1px; color: #BFCCE4" />
    <h2 class="mt-4">{{ sensor_name }}</h2>
    <hr class="mt-4" style="border-top: solid 1px; color: #BFCCE4" />
    <v-card class="mt-4" height="100%" flat v-show="visualizza_dati && !scelta">
      <v-card-text>

        <!-- <v-layout class="mt-4 mr-4 mb-4 ml-4">
                        <v-flex xs12 sm12 md6> -->
        <!-- <v-card height="100%" class="mt-4 mr-4 mb-4 ml-4" flat>
                                <v-card-text>
                                    <h2 class="align-center justify-center">DATA MANAGER</h2>
                                </v-card-text>
                                <v-layout>
                                    <v-flex sm6 md6 >
                                      <img class="mt-8 mr-16 align-left" :src="sensor_img" width="70%"/>
                                    </v-flex>
                                    <v-flex sm6 md6>
                                        <v-card-text class="text-left">
                                            <h3>Sensor name:</h3> {{ sensor_name }}
                                            <h3 class="mt-8">Building:</h3> {{ building_name }}
                                            <h3 class="mt-12">Floor: </h3> {{ floor_name }}
                                            <h3 class="mt-8">Level status: </h3> <v-icon :color="colore_stato">mdi-circle</v-icon> -->
        <!-- <h3>Last time empty: </h3> {{ last_refill }} -->
        <!-- </v-card-text>
                                    </v-flex>
                                </v-layout>
                            </v-card> -->
        <!-- </v-flex>
                        <div style="border-left: 1px solid #BFCCE4; height: 350px;" class="mt-4"></div>
                        <v-flex xs12 sm12 md6>
                            <v-card height="100%" class="mt-4 mr-4 mb-4 ml-4" flat>
                                <v-card-text>
                                    <h2 style="color: #213A8F !important">AIR QUALITY</h2>
                                </v-card-text>
                                <v-card-text class="justify-center">
                                <v-layout>
                                    <v-flex xs12 sm12 md12 class="justify-center mt-8"> -->
        <!-- <apexchartComponent type="radialBar" height="350" :options="PunctualchartOptions" :series="series_punctual" :key="radialKey"></apexchartComponent> -->
        <!-- <apexchartComponent type="bar" height="50" :options="PunctualchartOptions" :series="series_punctual" :key="keyPunctual"></apexchartComponent>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm12 md12 class="text-center mt-4">
                                        <div class="mt-4" style="display: inline-block;"><h3 style="display: inline-block;">Date: </h3> <h4 style="display: inline-block; font-weight: normal;">{{ DataSensore }}</h4></div>
                                        <div class="mt-8"><h3 style="display: inline-block;"></h3> <h4 style="display: inline-block; font-weight: normal;">{{ GiornoSettimana }}</h4></div>
                                        <div class="mt-8"><h3 style="display: inline-block;">Time: </h3> <h4 style="display: inline-block; font-weight: normal;"> {{ OraSensore }}</h4></div>
                                    </v-flex>
                                </v-layout>
                                
                                </v-card-text>
                            </v-card> -->
        <!-- </v-flex>
                </v-layout > -->
        <!-- <hr class="mt-4" style="border-top: solid 1px; color: #BFCCE4"/> -->
        <v-layout>

          <v-flex xs4 sm4 md4>
            <v-btn text @click="ChangeDate('1', 'CO2')" color="#234a98" class="mt-4 mb-4 mr-4 ml-4">
              <h2>CO2</h2>
            </v-btn>
          </v-flex>
          <v-flex xs4 sm4 md4>
            <v-btn text @click="ChangeDate('1', 'HUMIDITY')" color="#234a98" class="mt-4 mb-4 mr-4 ml-4">
              <h2>HUMIDITY</h2>
            </v-btn>
          </v-flex>
          <v-flex xs4 sm4 md4>
            <v-btn text @click="ChangeDate('1', 'TEMPERATURE')" color="#234a98" class="mt-4 mb-4 mr-4 ml-4">
              <h2>TEMPERATURE</h2>
            </v-btn>
          </v-flex>
          <v-flex xs4 sm4 md4>
            <v-btn text @click="ChangeDate('1', 'PRESSURE')" color="#234a98" class="mt-4 mb-4 mr-4 ml-4">
              <h2>PRESSURE</h2>
            </v-btn>
          </v-flex>
        </v-layout>
        <hr class="mt-4" style="border-top: solid 1px; color: #BFCCE4" />
        <h2 style="margin-top: 15px;">{{ chart_title }}</h2>
        <v-card-text>
          <apexchartComponent type="line" height="350" :options="chartOptions_bin" :series="series_bin" :key="chartk" />
        </v-card-text>
      </v-card-text>
    </v-card>
    <v-card>

    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
// import AnimatedNumber from "animated-number-vue";
export default {

  // components: {
  //     AnimatedNumber
  // },
  name: 'SmartBinView',
  data() {
    return {
      scelta: true,
      client: "",
      clients: [],
      buildingActive: true,
      areaActive: true,
      building: "",
      buildings: [],
      floor: "",
      floors: [],
      area: "",
      areas: [],
      sensorActive: true,
      floorActive: true,
      sensor_id: "",
      sensor_items: [],
      sensorsValue: "",
      okActive: true,
      colore4h: "#DAE0EC",
      colore1d: "#DAE0EC",
      colore3d: "#DAE0EC",
      colore1w: "#DAE0EC",
      colore2w: "#DAE0EC",
      request: "CO2",
      sensor_unique: 'FCA84A030000066C',
      maxDate: "",
      minDate: "",
      chartk: 0,
      chart_title: '',
      visualizza_dati: true,
      overlay: false,
      show: true,
      sensor_name: "Air Quality Office",
      to_display: [{ text: "Hourly", value: 0 }, { text: "Daily", value: 1 }, { text: "Weekly", value: 2 }],
      displayed_range: "",
      sensor_datas: [],
      menu: false,
      date: [],
      floor_items: [],
      floorValue: "",
      buildingValue: [],
      lista_bin: [{ text: "test Bin Sensor" }],
      valueBin: [],
      dialogBin: false,
      series_bin: [],


      chartOptions_bin: {
        chart: {
          toolbar: {
            show: false,
          },
          type: 'line',
          height: 650,
        },
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0
            }
          }
        }],
        stroke: {
          curve: 'smooth'
        },
        yaxis: {
          title: {
            text: '',
            rotate: 360,
            offsetY: -160,


          },
          // min: 0,
          // max: 100,

          labels: {
            offset: 10,
            formatter: function (value) {
              return Number(value).toFixed(2);
            },
          }
        },
        xaxis: {
          categories: [
          ],
          labels: {
            style: {
              colors: [],
              fontSize: '10px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 400,
              cssClass: 'apexcharts-xaxis-label',
            },
          },
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: 'right',
          offsetX: 0,
          offsetY: 50
        },
      },
    }
  },
  created() {
    if (this.$store.state.company == null || this.$store.state.company == undefined || this.$store.state.company == '') {
      let token = localStorage.getItem("token");
      if (token != null && token != undefined && token != '') {
        axios.defaults.headers.common["Authorization"] = token;
        axios.post(this.$store.state.URL_REFRESH_TOKEN,
          {

          })
          .then(res => {
            if (res.data.result == "ok") {
              this.$store.state.company = res.data.company;
              localStorage.setItem('token', res.data.token);
              localStorage.setItem('company', res.data.company)
              this.$store.state.menu = res.data.menu;
              console.log(this.$store.state.menu)
              this.$store.state.avatar = res.data.avatar;
              this.$store.state.displayName = res.data.displayName;
              axios.defaults.headers.common["Authorization"] = res.data.token;
              axios.post(this.$store.state.URL_COMPANY_DATA, {
                "Company": this.$store.state.company
              })
                .then(() => {
                  this.overlay = true;
                  this.DownloadCompanyDatas();
                  // this.colore1d = "#213A8F"
                  // this.$store.state.building = res.data
                })
                .catch(() => {
                  this.overlay = false;
                  this.$router.push({ path: "/" });
                })
            }
          })
      }
    }
    else {
      this.overlay = true;
      this.DownloadCompanyDatas();
    }
  },
  mounted() {
    // this.loading = true;
    // this.displayed_range = 0;
    // this.date.push(new Date().toISOString().toString().substr(0, 10));
    // this.ChangeDate('1', "CO2")


  },
  methods: {
    DownloadCompanyDatas() {
      axios.post(this.$store.state.URL_GET_AVAILABLE_CLIENT)
        .then(res => {
          res.data.forEach(el => {
            var element = { text: el.CompanyName, value: el.id }
            this.clients.push(element);

          })
        })
      // .catch(() => {
      //     this.overlay = false;
      //     this.$router.push({ path: "/" });
      // })
      axios.post(this.$store.state.URL_COMPANY_DATA, {
        "Company": this.$store.state.company
      })
        .then(res => {
          this.$store.state.building = res.data
          this.building_items.length = 0;
          this.floor_items.length = 0;

          this.$store.state.building.buildings.forEach(el => {
            var found = false;
            var c = 0;
            el.floors.forEach(e => {
              e.sensors.forEach(s => {
                found = Object.values(s).includes("Air")
                if (found)
                  c++;
                console.log(e, found)
              })

            })

            if (c > 0) {
              if (this.$store.state.company == '1')
                this.building_items.push({ text: el.BuildingName.replace('Zwetko Headquarter', 'Airport'), value: el });
              else
                this.building_items.push({ text: el.BuildingName, value: el });
            }
          })
        })
        .catch(() => {
          //Redirect alla pagina di errore
          //this.snackbar = true;
        })
    },
    ChangeDate(period, req) {
      this.visualizza_dati = true;
      this.scelta = false;
      this.overlay = true;
      console.log(period, req);
      switch (period) {
        case "4h":
          this.GetSensorData(this.subtractHours(4, new Date()).toISOString().toString().substr(0, 19), new Date().toISOString().toString().substr(0, 19), req);
          // this.chartOptions_stacked.plotOptions.bar.columnWidth = "15%"
          this.colore4h = "#213A8F"
          this.colore1d = "#DAE0EC"
          this.colore3d = "#DAE0EC"
          this.colore1w = "#DAE0EC"
          this.colore2w = "#DAE0EC"
          break;
        case "1":
          this.GetSensorData(this.subtractDays(0, new Date()).toISOString().toString().substr(0, 10), this.subtractDays(1, new Date()).toISOString().toString().substr(0, 10), req);
          // this.chartOptions_stacked.plotOptions.bar.columnWidth = "15%"
          this.colore4h = "#DAE0EC"
          this.colore1d = "#213A8F"
          this.colore3d = "#DAE0EC"
          this.colore1w = "#DAE0EC"
          this.colore2w = "#DAE0EC"
          break;
        case "3":
          this.GetSensorData(this.subtractDays(-2, new Date()).toISOString().toString().substr(0, 10), this.subtractDays(1, new Date()).toISOString().toString().substr(0, 10), req);
          // this.chartOptions_stacked.plotOptions.bar.columnWidth = "40%"
          this.colore3d = "#213A8F";
          this.colore4h = "#DAE0EC"
          this.colore1d = "#DAE0EC"
          this.colore1w = "#DAE0EC"
          this.colore2w = "#DAE0EC"
          break;
        case "7":
          this.GetSensorData(this.subtractDays(-6, new Date()).toISOString().toString().substr(0, 10), this.subtractDays(1, new Date()).toISOString().toString().substr(0, 10), req);
          // this.chartOptions_stacked.plotOptions.bar.columnWidth = "70%"
          this.colore1w = "#213A8F";
          this.colore3d = "#DAE0EC";
          this.colore4h = "#DAE0EC"
          this.colore1d = "#DAE0EC"
          this.colore2w = "#DAE0EC"
          break;
        case "14":
          this.GetSensorData(this.subtractDays(-13, new Date()).toISOString().toString().substr(0, 10), this.subtractDays(1, new Date()).toISOString().toString().substr(0, 10), req);
          // this.chartOptions_stacked.plotOptions.bar.columnWidth = "70%"
          this.colore2w = "#213A8F";
          this.colore1w = "#DAE0EC";
          this.colore3d = "#DAE0EC";
          this.colore4h = "#DAE0EC"
          this.colore1d = "#DAE0EC"
          break;
      }
    },
    subtractHours(numOfHours, date = new Date()) {
      date.setHours(date.getHours() - numOfHours + 1);
      return date;
    },
    subtractDays(numOfDays, date = new Date()) {
      date.setDate(date.getDate() + numOfDays);

      return date;
    },

    SetMinDate() {
      this.minDate = this.maxDate;
    },
    GetDataByDate() {
      this.overlay = true;
      this.GetSensorData(this.subtractDays(0, new Date(this.date[0])).toISOString().toString().substr(0, 10), this.subtractDays(1, new Date(this.date[1])).toISOString().toString().substr(0, 10));
    },
    addDays(date, days) {
      date.setDate(date.getDate() + days);
      return date;
    },
    GetSensorData(start, nextDay, req = "CO2") {
      start = start.length == 10 ? start + " 00:00:00" : start.replace("T", " ");
      nextDay = nextDay.length == 10 ? nextDay + " 00:00:00" : nextDay.replace("T", " ");
      var data_ = [];
      
      this.chartOptions_bin.xaxis.categories.length = 0;
      // this.sensor_datas.length = 0;
      //this.sensor_datas = res.data;
      console.log(start, nextDay, req)
      this.series_bin.length = 0;
      axios.post(this.$store.state.URL_GET_DATA_FROM_DYNAMO,
        {
          "sensor_id": this.sensor_unique,
          "from": start,
          "to": nextDay
        }
      )
        .then(res => {
          switch (req) {
            case ('CO2'):
              this.request = 'CO2';
              this.chartOptions_bin.yaxis.title.text = '(ppm)';
              this.chart_title = req + " Level"
              for(var y = 0; y < res.data.length; y++){
                // this.chartOptions_bin.xaxis.categories.push(res.data[y].device_data.received_at.substr(0, 10) + "-" + res.data[y].device_data.received_at.substr(11, 5));
                this.chartOptions_bin.xaxis.categories.push(res.data[y].device_data.received_at)
                console.log(res.data[y].device_data.received_at.substr(0, 10) + "-" + res.data[y].device_data.received_at.substr(11, 5) + " - " + res.data[y].device_data.co2_ppm);
                data_.push(res.data[y].device_data.co2_ppm);
              }
              // dati.forEach(el => {
              //   this.chartOptions_bin.xaxis.categories.push(el.received_at.substr(0, 10) + "-" + el.received_at.substr(11, 5));
              //   console.log(el);
              //   data_.push(el.co2_ppm);
              // });
              break;
            case ('HUMIDITY'):
              this.request = 'HUMIDITY'
              this.chartOptions_bin.yaxis.title.text = '(%RH)';
              this.chart_title = req.charAt(0).toUpperCase() + req.slice(1).toLowerCase() + " Level"
              res.data.forEach(el => {
                this.chartOptions_bin.xaxis.categories.push(el.device_data.received_at.substr(0, 10) + "-" + el.device_data.received_at.substr(11, 5));
                data_.push(el.device_data.humidity);
              });
              break;
            case ('TEMPERATURE'):
              this.request = 'TEMPERATURE'
              this.chartOptions_bin.yaxis.title.text = '(°C)';
              this.chart_title = req.charAt(0).toUpperCase() + req.slice(1).toLowerCase() + " Level"
              res.data.forEach(el => {
                this.chartOptions_bin.xaxis.categories.push(el.device_data.received_at.substr(0, 10) + "-" + el.device_data.received_at.substr(11, 5));
                data_.push(el.device_data.internal_temperature);
              });
              break;
            case ('PRESSURE'):
              this.request = 'PRESSURE'
              this.chartOptions_bin.yaxis.title.text = '(mBar)';
              this.chart_title = req.charAt(0).toUpperCase() + req.slice(1).toLowerCase() + " Level"
              res.data.forEach(el => {
                this.chartOptions_bin.xaxis.categories.push(el.device_data.received_at.substr(0, 10) + "-" + el.device_data.received_at.substr(11, 5));
                data_.push(el.device_data.pressure);
              });
              break;
            default:
              break;

          }

          this.series_bin.push({ data: data_, name: req });
          console.log(data_);
          this.chartk++;
          this.overlay = false;
          console.log("END")
        })
        .catch(() => {
          this.overlay = false;
        })
    },
    goBack() {
        if (window.history.length > 1) {
            this.$router.go(-1);
        } else {
            this.$router.push('/welcome');
        }
    },
    LoadData() {
      this.scelta = false;
      this.overlay = true;
      this.ChangeDate('1', 'CO2');
    }
  },
  watch: {
    client(value) {
      if (value != undefined &&
        value != null &&
        value != "" &&
        value != 0
      ) {
        this.buildingActive = false;
        this.buildings.length = 0;
        this.buildingValue = '';
        this.buildings = [];
        this.floorActive = true;
        this.floors.length = 0;
        this.floor = '';
        this.floors = [];
        this.floors.length = 0;
        this.areaActive = true;
        this.areas.length = 0;
        this.area = '';
        this.areas = [];
        this.areas.length = 0;
        this.sensorActive = true;
        this.sensor_items.length = 0;
        this.sensorsValue = '';
        this.sensor_items = [];
        this.sensor_items.length = 0;
        this.building_name = '';
        axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
          companyId: value
        })
          .then(res => {
            res.data.forEach(el => {
              var element = { text: el.BuildingName, value: el.id }
              this.buildings.push(element);

            });
          })
      }
      else {
        this.buildingActive = false;
        this.buildings.length = 0;
        this.buildingValue = '';
        this.buildings = [];
        this.building_name = '';
        this.floorActive = true;
        this.floors.length = 0;
        this.floor = '';
        this.floors = [];
        this.floors.length = 0;
        this.areaActive = true;
        this.areas.length = 0;
        this.area = '';
        this.areas = [];
        this.areas.length = 0;
        this.sensorActive = true;
        this.sensor_items.length = 0;
        this.sensorsValue = '';
        this.sensor_items = [];
        this.sensor_items.length = 0;
      }

    },
    building(value) {
      if (value != undefined &&
        value != null &&
        value != "" &&
        value != 0
      ) {


        this.floorActive = true;
        this.floors.length = 0;
        this.floor = '';
        this.floors = [];
        this.floor_name = '';
        this.floors.length = 0;
        this.areaActive = true;
        this.areas.length = 0;
        this.area = '';
        this.areas = [];
        this.areas.length = 0;
        this.sensorActive = true;
        this.sensor_items.length = 0;
        this.sensorsValue = '';
        this.sensor_items = [];
        this.sensor_items.length = 0;
        const selectedOption = this.buildings.find(option => option.value === value);
        this.building_name = selectedOption.text
        this.floorActive = false;
        axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
          buildingId: value
        })
          .then(res => {
            res.data.forEach(el => {
              var element = { text: el.FloorName, value: el.id }
              this.floors.push(element);
            });

          })
      }
      else {
        this.floorActive = false;
        this.floors.length = 0;
        this.floor = '';
        this.floors = [];
        this.floor_name = '';
        this.floors.length = 0;
        this.areaActive = true;
        this.areas.length = 0;
        this.area = '';
        this.areas = [];
        this.areas.length = 0;
        this.sensorActive = true;
        this.sensor_items.length = 0;
        this.sensorsValue = '';
        this.sensor_items = [];
        this.sensor_items.length = 0;
      }
    },
    floor(value) {
      if (value != undefined &&
        value != null &&
        value != "" &&
        value != 0
      ) {

        this.areaActive = true;
        this.areas.length = 0;
        this.area = '';
        this.areas = [];
        this.areas.length = 0;
        this.sensorActive = true;
        this.sensor_items.length = 0;
        this.sensorsValue = '';
        this.sensor_items = [];
        this.sensor_items.length = 0;
        this.areaActive = false;
        const selectedOption = this.floors.find(option => option.value === value);
        this.floor_name = selectedOption.text
        axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
          floorId: value
        })
          .then(res => {
            res.data.forEach(el => {
              var element = { text: el.AreaName, value: el.id }
              this.areas.push(element);
            });

          })
      }
      else {

        this.areaActive = false;
        this.areas.length = 0;
        this.area = '';
        this.areas = [];
        this.areas.length = 0;
        this.sensorActive = true;
        this.sensor_items.length = 0;
        this.sensorsValue = '';
        this.sensor_items = [];
        this.sensor_items.length = 0;
      }

    },
    area(value) {
      if (value != undefined &&
        value != null &&
        value != "" &&
        value != 0
      ) {
        this.sensor_items.length = 0;
        this.sensor_items = [];
        this.sensorsValue = "";
        this.sensorActive = false;
        // var el = { text: "...", value: "" };
        // this.filterSensors.push(el);
        axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
          companyId: this.client,
          buildingId: this.building,
          floorId: this.floor,
          areaId: value,
          type: "Air"
        })
          .then(res => {
            res.data.forEach(el => {
              var element = { text: el.DisplayName, value: el }
              this.sensor_items.push(element);
            });

          })
      }
      else {
        this.sensor_items.length = 0;
        this.sensor_items = [];
        this.sensorsValue = "";
      }
    },
    buildingValue(value) {
      this.visualizza_dati = false;
      this.floor_items.length = 0;
      this.sensor_items.length = 0;
      value.floors.forEach(el => {
        this.floor_items.push({ text: el.FloorName, value: el })
      })
      this.building_name = value.BuildingName;
      this.floorActive = false;
      this.sensorActive = true;
      this.sensor_name = "";
      this.sensor_img = "";
      this.floor_name = "";
      this.f++;
      this.s++;
    },
    floorValue(value) {
      this.visualizza_dati = false;
      this.sensor_items.length = 0;
      value.sensors.forEach(el => {
        if (el.DispenserType == "Dispenser")
          this.sensor_items.push({ text: el.DisplayName, value: el })
      })

      this.floor_name = value.FloorName;
      this.sensor_name = "";
      this.sensor_img = "";
      this.sensorActive = false;
      this.sensorsValue = '';
      this.s++;
    },
    sensorsValue(value) {
      //this.visualizza_dati = true;
      this.sensor_name = value.DisplayName;
      this.sensor_img = value.DispenserImage;
      this.sensor_unique = value.DispenserUnique;
      this.sensor_id = value.DispenserId;
      this.minValue = value.Min_Value;
      this.maxValue = value.Max_Value;
      this.okActive = false;
      this.colore4h = "#DAE0EC"
      this.colore1d = "#213A8F"
      this.colore3d = "#DAE0EC"
      this.colore1w = "#DAE0EC"
      this.colore2w = "#DAE0EC"
      this.date = [];
      this.ChangeDate('1', 'CO2');
    }
  },

}

</script>
